/**
 * Send a pageview to Segment.
 * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#page
 */
export const page = (url: string) => {
    if ((window as any).analytics == null) return;

    (window as any).analytics.page(url);
};
